/**
 * Vendor with basic properties.
 * E.g. UID and email for listing.
 */
export type BasicVendor = {
  uid: string;
  email: string;
};
